import {
  useAccountClaimAnalyticsParams,
  useDefaultAnalyticsParams
} from "core/analytics/analytics-params.hooks";
import { useEffect } from "react";
import ReactGA from "react-ga4";
import { useLocation } from "react-router-dom";

export const useInitGoogleAnalytics = () => {
  const gaMeasurementId = window.appConfig.gtmId;

  const { userId } = useAccountClaimAnalyticsParams();

  if (!ReactGA.isInitialized && gaMeasurementId) {
    ReactGA.initialize(gaMeasurementId, {
      gaOptions: {
        userId
      }
    });
  }
};

export const useGoogleAnalyticsPageTracking = () => {
  const { pathname } = useLocation();
  const defaultParams = useDefaultAnalyticsParams();

  useEffect(
    () => {
      ReactGA.send({
        hitType: "pageview",
        pageLocation: pathname,
        ...defaultParams
      });
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [pathname]
  );
};
